import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';
import queryString from 'query-string';
//
import { createStructuredSelector } from 'reselect';
import {
  getServiceMetrics,
  getLinkMetrics,
  getError,
  getDurations,
  getIsFetching,
} from 'store/selectors/metrics';
import {
  getServiceMetricsFromServer,
  getLinkMetricsFromServer,
} from 'store/actions/metrics';
//
import DateRangePicker from 'components/blocks/DateRangePicker';
import { Loading } from 'components/blocks';
import TemplatePerf from './TemplatePerf';
import TemplateLinksPerf from './TemplateLinksPerf';

// eslint-disable-next-line react/prefer-stateless-function
class TemplatePerfPage extends Component {
  constructor(props) {
    super(props);
    if (props.durations.length === 2) {
      this.state = {
        startDate: moment(props.durations[0]),
        endDate: moment(props.durations[1]),
      };
    } else {
      this.state = {
        startDate: moment().startOf('month'),
        endDate: moment(),
      };
    }
  }

  handleDateRangeChange = async dates => {
    const flags = global.location && queryString.parse(global.location.search);
    const seeded = flags.mode && flags.mode === 'seed';

    if (!seeded) {
      const { templateId } = this.props.match.params;
      await Promise.all([
        this.props.getServiceMetrics(templateId, dates[0], dates[1]),
        this.props.getLinkMetrics(templateId, dates[0], dates[1]),
      ]);
    }

    this.setState({
      startDate: dates[0],
      endDate: dates[1],
    });
  };

  render() {
    const { isLoading } = this.props;
    const { templateName } = this.props.match.params;
    const { startDate, endDate } = this.state;

    return (
      <Fragment>
        <header>
          <h2>
            {templateName} {isLoading && <Loading />}
          </h2>
        </header>
        <DateRangePicker
          endDate={endDate}
          startDate={startDate}
          onDateRangeChange={this.handleDateRangeChange}
        />
        <TemplatePerf {...this.props} {...this.state} />
        <TemplateLinksPerf {...this.props} {...this.state} />
      </Fragment>
    );
  }
}

const selector = createStructuredSelector({
  error: getError,
  serviceMetrics: getServiceMetrics,
  linkMetrics: getLinkMetrics,
  durations: getDurations,
  isLoading: getIsFetching,
});

const actions = {
  getServiceMetrics: getServiceMetricsFromServer,
  getLinkMetrics: getLinkMetricsFromServer,
};

TemplatePerfPage.defaultProps = {
  isLoading: false,
  durations: [],
};

TemplatePerfPage.propTypes = {
  error: PropTypes.string.isRequired,
  getLinkMetrics: PropTypes.func.isRequired,
  getServiceMetrics: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  durations: PropTypes.array,
  match: ReactRouterPropTypes.match.isRequired,
};

export default withRouter(
  connect(
    selector,
    actions,
  )(TemplatePerfPage),
);
